/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import {Navigate, Outlet, useLocation} from 'react-router-dom';
import {useAppSelector} from 'src/redux/store';
import {useRefreshTokenMutation} from 'src/redux/api/authApi';
import {CircularProgress} from '@mui/material';

export type RutaProtegidaProps = {
	rolesPermitidos: string[] | undefined;
};

function RutaProtegida({rolesPermitidos}: RutaProtegidaProps) {
	const location = useLocation();
	const estadoUsuario = useAppSelector((estadoApp) => estadoApp?.usuario?.usuario ?? null);
	const [cargando, setCargando] = React.useState(true);
	const [refreshToken] = useRefreshTokenMutation();
	React.useEffect(() => {
		if (!estadoUsuario) {
			refreshToken().unwrap().finally(() => {
				setCargando(false);
			});
		} else {
			setCargando(false);
		}
	}, [estadoUsuario, refreshToken]);


	if (cargando) {
		return <CircularProgress color="primary" sx={{mt: 10}}/>;
	}

	return <Outlet />;

	// if (estadoUsuario && rolesPermitidos) {
	// 	let puedeAcceder = true;
	// 	estadoUsuario.roles.forEach((rol) => {
	// 		if (rolesPermitidos.includes(rol.id)) {
	// 			puedeAcceder = true;
	// 		}
	// 	});
	// 	if (puedeAcceder) {
	// 		return <Outlet />;
	// 	}

	// 	return <Navigate to="/no-autorizado" state={{from: location}} replace />;
	// }

	// return <Navigate to="/" state={{from: location}} replace />;
}

export default RutaProtegida;
